import { withInstall } from '@lit-element/utils'
import Popper from './src/popper.vue'

import LtPopperArrow from './src/arrow.vue'
import LtPopperTrigger from './src/trigger.vue'
import LtPopperContent from './src/content.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export { LtPopperArrow, LtPopperTrigger, LtPopperContent }

export const LtPopper: SFCWithInstall<typeof Popper> = withInstall(Popper)
export default LtPopper

export * from './src/popper'
export * from './src/trigger'
export * from './src/content'
export * from './src/arrow'
export * from './src/constants'

export type { Placement, Options } from '@popperjs/core'
